import React, { useState } from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1 } from '../../../styles';
import { Form, Button, Input, Radio } from 'antd';
import { Merchant } from '../../../models';

import { alertify, handleApiExceptions } from '../../../app_methods';


let LoadAccountModalForm = (props) => {
    const { form, merchant, account } = props;
    const { getFieldDecorator } = form;
    const [isSubmitting, setIsSubmitting] = useState(false);



    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err) => {
            if (err) return;
            loadAmount(form.getFieldsValue());
        });
    };

    const loadAmount = async (values) => {
        setIsSubmitting(true);
        const response = await Merchant.load_amount(values);
        if (!response.success) {
            setIsSubmitting(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", `Account balance updated successfully.`, "success");
        setIsSubmitting(false);
        props.fetchBlance(account.id)
        props.toggleAmountLoadModal()
        props.fetchMerchantInfo()
    }
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>Manage Funds</Text1>
        )
    };

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={props.toggleAmountLoadModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <Form onSubmit={onSubmit}>
                {getFieldDecorator("account_id", {
                    initialValue: account?.id
                })(<Input autoComplete='off' hidden />)}
                <Form.Item label={'Action'} >
                    {getFieldDecorator("transaction_type", {
                        rules: [{ required: true, message: "Please select action." }],
                    })(
                        <Radio.Group>
                            <Radio value="credit">Add Balance</Radio>
                            <Radio value="debit">Withdraw Balance</Radio>
                        </Radio.Group>
                    )}
                </Form.Item>
                <Form.Item label={'Amount'} >
                    {getFieldDecorator("amount", {
                        rules: [{ required: true, message: "Amount is required." },
                        {
                            pattern: new RegExp(/^\d+(\.\d{1,2})?$/), message: "Please enter a valid amount upto 2 decimal places.",
                        },],

                    })(<Input placeholder={"Enter valid amount"}></Input>)}
                </Form.Item>
                <div className="w-100 d-flex justify-content-end mt-4">
                    <Button type="primary" htmlType="submit" loading={isSubmitting}>Submit</Button>
                </div>
            </Form>
        </EaseModal>
    )
};

const LoadAccountModal = Form.create()(LoadAccountModalForm);

export { LoadAccountModal };